<template>
  <strong
    class="px-1.5 rounded select-all"
    :class="color"
    v-bind="$attrs"
    v-html="value"
  />
</template>

<script>
import chunk from 'lodash/chunk';
import { computed } from 'vue';

export default {
  inheritAttrs: false,
  props: {
    value: {
      type: [String, Number],
      required: true,
    },
    chunk: {
      type: [String, Number],
      default: null,
    },
    color: {
      type: String,
      default: 'default',
    },
    glue: {
      type: String,
      default: '-'
    },
  },
  setup(props) {
    const separator = computed(() =>
      `<span class="select-none">${props.glue}</span>`
    );

    const value = computed(() => props.chunk
        ? chunk(props.value, props.chunk)
          .map(value => value.join(''))
          .join(separator.value)
        : props.value
    );

    const color = computed(() => ({
      default: 'bg-opacity-10 bg-blue-500 text-blue-500',
      pga:     'bg-opacity-10 bg-pga-500 text-pga-500',
      pgb:     'bg-opacity-10 bg-pgb-500 text-pgb-500',
      pgc:     'bg-opacity-10 bg-pgc-500 text-pgc-500',
    }[props.color]));

    return {
      value,
      color,
    }
  }
}
</script>
